import axios from 'axios'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import { ConfigurationPreformattedCreateRequest, ConfigurationPreformattedPatchInBatchRequest, ConfigurationPreformattedResponse } from '@/modules/configurationModule/detail/local-samples/preformatted/services/preformatted.dto'

class PreformattedGridConfigurationServices {
    async paginator(filterModel: CommonFilterModel, params: CommonParams, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationPreformattedResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationPreformattedResponse>>(`/configuration/laboratories/${laboratoryId}/preformatted`, filterModel, { params })
        return response.data
    }

    async getPreformattedById(laboratoryId: number, preformattedId: number): Promise<ConfigurationPreformattedResponse> {
        const response = await axios.get<ConfigurationPreformattedResponse>(`/configuration/laboratories/${laboratoryId}/preformatted/${preformattedId}`)
        return response.data
    }

    async createPreformatted(laboratoryId: number, request: ConfigurationPreformattedCreateRequest): Promise<ConfigurationPreformattedResponse> {
        const response = await axios.post<ConfigurationPreformattedResponse>(`/configuration/laboratories/${laboratoryId}/preformatted`, request)
        return response.data
    }

    async deletePreformatted(laboratoryId: number, preformattedIds: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/preformatted/batch`, { data: preformattedIds })
        return response.data
    }

    async patchPreformatted(laboratoryId: number, requests: ConfigurationPreformattedPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/preformatted/batch`, requests)
        return response.data
    }
}

export const preformattedGridConfigurationServices = new PreformattedGridConfigurationServices()
